import * as React from 'react';

const TableFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="table-fill_svg__eds-icon--table-fill_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="table-fill_svg__eds-icon--table-fill_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 7v10h16V7H4z"
        />
        <g
            id="table-fill_svg__eds-icon--table-fill_circles"
            fillRule="evenodd"
            clipRule="evenodd"
        >
            <circle cx={6} cy={4} r={2} />
            <circle cx={12} cy={4} r={2} />
            <circle cx={18} cy={4} r={2} />
            <circle cx={6} cy={20} r={2} />
            <circle cx={12} cy={20} r={2} />
            <circle cx={18} cy={20} r={2} />
        </g>
    </svg>
);

TableFillSvg.displayName = 'TableFillSvg';
export default TableFillSvg;
